var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6068 13.9467L26.3534 10.24L26.8068 5.33333L21.9934 4.24L19.4734 0L14.9401 1.94667L10.4068 0L7.88677 4.24L3.07344 5.32L3.52677 10.2267L0.273438 13.9467L3.52677 17.6533L3.07344 22.5733L7.88677 23.6667L10.4068 27.9067L14.9401 25.9467L19.4734 27.8933L21.9934 23.6533L26.8068 22.56L26.3534 17.6533L29.6068 13.9467ZM12.2734 20.6133L6.9401 15.28L8.8201 13.4L12.2734 16.84L21.0601 8.05333L22.9401 9.94667L12.2734 20.6133Z",
    fill: "#008934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.62dc4cd8e1e63231514ac22b249106d5.svg";
export { ForwardRef as ReactComponent };